import { FeatureIconType } from 'core/components/icons/types'
import React, { useEffect, useRef } from 'react'
import { ReactComponent as BeachChair } from './svg/feature/beach-chair.svg'
import { ReactComponent as CarInMotion } from './svg/feature/car-in-motion.svg'
import { ReactComponent as Everlance } from './svg/feature/everlance.svg'
import { ReactComponent as EverlanceLogo } from './svg/feature/everlance-logo.svg'
import { ReactComponent as Expenses } from './svg/feature/expenses.svg'
import { ReactComponent as Tags } from './svg/feature/tags.svg'
import { ReactComponent as WorkHours } from './svg/feature/work-hours.svg'
import { ReactComponent as DataExports } from './svg/feature/data-exports.svg'
import { ReactComponent as WalletSendPayments } from './svg/feature/wallet-send-payments.svg'
import { ReactComponent as MoneyInWallet } from './svg/feature/money-in-wallet.svg'
import { ReactComponent as PayReport } from './svg/feature/pay-report.svg'
import { ReactComponent as Rules } from './svg/feature/rules.svg'
import { ReactComponent as Flags } from 'core/components/icons/svg/feature/flags.svg'
import { ReactComponent as Wallet } from 'core/components/icons/svg/feature/wallet.svg'
import { ReactComponent as Calendar } from 'core/components/icons/svg/feature/calendar.svg'
import { ReactComponent as FlagsBanner } from 'core/components/icons/svg/feature/flags-banner.svg'
import { ReactComponent as Insurance } from 'core/components/icons/svg/feature/insurance.svg'
import { ReactComponent as Categories } from 'core/components/icons/svg/feature/categories.svg'
import { ReactComponent as DriverCheckup } from 'core/components/icons/svg/feature/driver-checkup.svg'
import { ReactComponent as SedanDriving } from 'core/components/icons/svg/feature/sedan-driving.svg'
import { ReactComponent as Product } from 'core/components/icons/svg/feature/product.svg'
import { ReactComponent as Time } from 'core/components/icons/svg/feature/time.svg'
import { ReactComponent as Trips } from 'core/components/icons/svg/feature/trips.svg'
import { ReactComponent as Transactions } from 'core/components/icons/svg/feature/transactions.svg'
import { ReactComponent as Share } from 'core/components/icons/svg/feature/share.svg'
import { ReactComponent as Reports } from 'core/components/icons/svg/feature/reports.svg'
import { ReactComponent as Premium } from 'core/components/icons/svg/feature/premium.svg'
import { ReactComponent as Location } from 'core/components/icons/svg/feature/location.svg'
import { ReactComponent as DataExport } from 'core/components/icons/svg/feature/data-export.svg'
import { ReactComponent as CreditCards } from 'core/components/icons/svg/feature/credit-cards.svg'
import { ReactComponent as ExpenseSync } from 'core/components/icons/svg/feature/expense-sync.svg'
import { ReactComponent as Confetti } from 'core/components/icons/svg/feature/confetti.svg'
import { ReactComponent as Clapping } from 'core/components/icons/svg/feature/clapping.svg'
import { ReactComponent as Visibility } from 'core/components/icons/svg/feature/visibility.svg'

import cn from 'classnames'

const Icons: Record<FeatureIconType, JSX.Element> = {
  'beach-chair': <BeachChair />,
  'car-in-motion': <CarInMotion />,
  everlance: <Everlance />,
  'everlance-logo': <EverlanceLogo />,
  expenses: <Expenses />,
  'money-in-wallet': <MoneyInWallet />,
  'pay-report': <PayReport />,
  tags: <Tags />,
  'work-hours': <WorkHours />,
  'data-exports': <DataExports />,
  'wallet-send-payments': <WalletSendPayments />,
  rules: <Rules />,
  flags: <Flags />,
  wallet: <Wallet />,
  calendar: <Calendar />,
  'flags-banner': <FlagsBanner />,
  insurance: <Insurance />,
  categories: <Categories />,
  'driver-checkup': <DriverCheckup />,
  'sedan-driving': <SedanDriving />,
  product: <Product />,
  time: <Time />,
  trips: <Trips />,
  transactions: <Transactions />,
  share: <Share />,
  reports: <Reports />,
  premium: <Premium />,
  location: <Location />,
  'data-export': <DataExport />,
  'credit-cards': <CreditCards />,
  'expense-sync': <ExpenseSync />,
  confetti: <Confetti />,
  clapping: <Clapping />,
  visibility: <Visibility />
}

interface FeatureIconProps {
  name: `${FeatureIconType}`
  width?: string | number
  height?: string | number
  className?: string
}

const FeatureIcon = ({ name, className, height, width }: FeatureIconProps) => {
  const svgRef = useRef<SVGSVGElement>(null)
  const Element = Icons[name]

  useEffect(() => {
    if (svgRef.current) {
      const defaultWidth = svgRef.current.getAttribute('width') ?? ''
      const defaultHeight = svgRef.current.getAttribute('height') ?? ''
      svgRef.current.setAttribute('width', (width as string) ?? defaultWidth)
      svgRef.current.setAttribute('height', (height as string) ?? defaultHeight)
    }
  }, [height, width])

  return (
    <span className={cn([className, 'flex items-center justify-center'])}>
      {React.cloneElement(Element, {
        ref: svgRef
      })}
    </span>
  )
}

export default FeatureIcon
